export const postsRoutes = {
  'route.posts.index': '/posts',
  'route.posts.show': '/posts/[slug]',
  'route.posts.category': '/posts/categories/[slug]',
  'route.posts.preview': '/posts/preview/[slug]',

  'api.posts.index': 'posts',
  'api.posts.item': 'posts/show/[slug]',
  'api.posts.item-preview': 'posts/preview/[slug]',
  'api.posts.types': 'posts/types',
  'api.posts.type-item': 'posts/types/show/[slug]',

  'api.posts.get-item-comments': 'posts/[id]/comments',
  'api.posts.submit-comment': 'posts/[id]/comment',
  'api.posts.like': 'posts/[id]/like',
  'api.posts.dislike': 'posts/[id]/dislike',
};
